import { ApiError, NetworkError } from '../../lib/api';

/** Maps a login failure to operator-facing copy without revealing which field was wrong. */
export function loginErrorMessage(err: unknown): string {
  if (err instanceof NetworkError)
    return 'Não foi possível contatar o servidor. Verifique sua conexão.';
  if (!(err instanceof ApiError)) return 'Ocorreu um erro inesperado. Tente novamente.';
  switch (err.status) {
    case 400:
      return 'Preencha organização, e-mail e senha.';
    case 401:
      return 'Organização, e-mail ou senha inválidos.';
    case 429: {
      const seconds = Number(err.headers.get('Retry-After'));
      const minutes = Number.isFinite(seconds) && seconds > 0 ? Math.ceil(seconds / 60) : null;
      return minutes
        ? `Muitas tentativas. Tente novamente em ${minutes} min.`
        : 'Muitas tentativas. Tente novamente mais tarde.';
    }
    case 503:
      return 'Autenticação temporariamente indisponível. Tente novamente em instantes.';
    default:
      return 'Ocorreu um erro inesperado. Tente novamente.';
  }
}
